import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Users as UsersIcon } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { AgentTimelineView } from "./AgentTaskTable";

export default function PeopleView({ members = [], agents = [] }) {
  const [productRows, setProductRows] = useState([]);
  const [agentRows, setAgentRows] = useState([]);
  const [personFilter, setPersonFilter] = useState("__all__");

  const loadAll = async () => {
    try {
      const [p, a] = await Promise.all([api.get("/product-tasks"), api.get("/agent-tasks")]);
      setProductRows(p.data);
      setAgentRows(a.data);
    } catch (e) { console.error(e); }
  };
  useEffect(() => { loadAll(); }, []);

  return (
    <div className="space-y-4" data-testid="people-view">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h3 className="font-display text-lg font-semibold flex items-center gap-2">
            <UsersIcon className="h-5 w-5 text-blue-600" /> People
          </h3>
          <p className="text-xs text-slate-500">
            A combined timeline of every person's work across Product, Bugs, and Agent Workflow.
            Use the dropdown on the right to focus on one teammate.
          </p>
        </div>
        <Select value={personFilter} onValueChange={setPersonFilter}>
          <SelectTrigger className="h-10 w-64 rounded-xl text-sm" data-testid="people-person-filter">
            <SelectValue placeholder="Filter by person" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__"><span className="text-slate-700">All people</span></SelectItem>
            <SelectItem value="__unassigned__"><span className="text-slate-500">Unassigned only</span></SelectItem>
            {members.map((m) => (
              <SelectItem key={m.id} value={m.email}>{m.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <AgentTimelineView
        rows={agentRows}
        productRows={productRows}
        agents={agents}
        members={members}
        personFilter={personFilter}
        onCommit={async (entry, patch) => {
          const nextTimeline = (entry.row_timeline || []).map((t) =>
            t.id === entry.id ? { ...t, ...patch } : t
          );
          if (entry.source === "product") {
            setProductRows((prev) => prev.map((r) => (r.id === entry.task_id ? { ...r, timeline: nextTimeline } : r)));
            try {
              const { data } = await api.patch(`/product-tasks/${entry.task_id}`, { timeline: nextTimeline });
              setProductRows((prev) => prev.map((r) => (r.id === entry.task_id ? data : r)));
            } catch { loadAll(); }
          } else {
            setAgentRows((prev) => prev.map((r) => (r.id === entry.task_id ? { ...r, timeline: nextTimeline } : r)));
            try {
              const { data } = await api.patch(`/agent-tasks/${entry.task_id}`, { timeline: nextTimeline });
              setAgentRows((prev) => prev.map((r) => (r.id === entry.task_id ? data : r)));
            } catch { loadAll(); }
          }
        }}
      />
    </div>
  );
}
